// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"72":"Cart","187":"NotFound","344":"FullPizza"}[chunkId] + "." + {"72":"e3f8676d","187":"8644b573","344":"d6b8d2ef"}[chunkId] + ".chunk.js";
};